import { logAppError } from 'Helpers/logger'
import {
  modalConfirmState,
  modalShedulingState,
  pageState,
  sendListState
} from '../states/page'
import getIntl from 'Helpers/intl'
import {
  cancelSchedule,
  deleteSending,
  enqueueRetry,
  getScheduledSendings,
  patchSchedule,
  updateScheduleState
} from '../actions/actions'
import { RCS_SENDING_NO_CREDIT } from 'Api/beRcsSend'
import {
  toastShow,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS
} from 'mailup-web-components'

export const resetCallback = ({ set, reset }) => async id => {
  reset(pageState)
  reset(sendListState)
  reset(modalShedulingState)
  reset(modalConfirmState)
}

export const initCallback = ({ set, snapshot }) => async () => {
  set(sendListState, prev => ({
    ...prev,
    loading: true
  }))
  try {
    const { orderBy, orderDescending } = await snapshot.getPromise(
      sendListState
    )

    const result = await getScheduledSendings({
      orderBy: orderBy,
      orderDescending: orderDescending
    })

    if (
      result.Items.filter(f => f.State === RCS_SENDING_NO_CREDIT).length > 0
    ) {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Rcs.SendStatusToastWarningNoCredits'
        }),
        TOAST_VARIANT_WARNING,
        'SendStatusToastWarningNoCredits'
      )
    }

    set(sendListState, prev => ({
      ...prev,
      items: result.Items,
      isEmptyState: result.Items.length === 0
    }))
  } catch (error) {
    logAppError({ appError: error })
    set(pageState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }
  set(sendListState, prev => ({
    ...prev,
    loading: false
  }))
}

export const reloadScheduledSendingsCallback = ({
  set,
  snapshot
}) => async () => {
  try {
    const { orderBy, orderDescending } = await snapshot.getPromise(
      sendListState
    )

    const result = await getScheduledSendings({
      orderBy: orderBy,
      orderDescending: orderDescending
    })

    if (
      result.Items.filter(f => f.State === RCS_SENDING_NO_CREDIT).length > 0
    ) {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Rcs.SendStatusToastWarningNoCredits'
        }),
        TOAST_VARIANT_WARNING,
        'SendStatusToastWarningNoCredits'
      )
    }
    set(sendListState, prev => ({
      ...prev,
      items: result.Items,
      isEmptyState: result.Items.length === 0
    }))
  } catch (error) {
    logAppError({ appError: error })
    set(pageState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }
}

export const enqueueErrorRetryCallback = ({
  set,
  snapshot
}) => async idQueuing => {
  try {
    const { orderBy, orderDescending } = await snapshot.getPromise(
      sendListState
    )

    await enqueueRetry(idQueuing)

    const result = await getScheduledSendings({
      orderBy: orderBy,
      orderDescending: orderDescending
    })

    set(sendListState, prev => ({
      ...prev,
      items: result.Items,
      isEmptyState: result.Items.length === 0
    }))
  } catch (error) {
    logAppError({ appError: error })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
}

export const sendMessageCallback = ({ set, snapshot, reset }) => async (
  idSchedule,
  scheduleDate,
  uITimezone
) => {
  try {
    const { orderBy, orderDescending } = await snapshot.getPromise(
      sendListState
    )
    const params = {
      Type: scheduleDate ? 'Scheduled' : 'Immediate'
    }
    if (scheduleDate) {
      params.ScheduleDate = scheduleDate
      params.UITimezone = uITimezone
    }
    const res = await patchSchedule(idSchedule, params)
    if (res.Result === true) {
      const result = await getScheduledSendings({
        orderBy: orderBy,
        orderDescending: orderDescending
      })
      set(sendListState, prev => ({
        ...prev,
        items: result.Items,
        isEmptyState: result.Items.length === 0
      }))
    } else {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'ErrorGeneric'
      )
    }
  } catch (error) {
    logAppError({ appError: error })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
  reset(modalShedulingState)
}

export const cancelScheduleCallback = ({
  set,
  snapshot,
  reset
}) => async idSchedule => {
  try {
    const { orderBy, orderDescending } = await snapshot.getPromise(
      sendListState
    )

    const res = await cancelSchedule(idSchedule)
    if (res.Result === true) {
      const result = await getScheduledSendings({
        orderBy: orderBy,
        orderDescending: orderDescending
      })
      set(sendListState, prev => ({
        ...prev,
        items: result.Items,
        isEmptyState: result.Items.length === 0
      }))
    } else {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'ErrorGeneric'
      )
    }
  } catch (error) {
    logAppError({ appError: error })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
  reset(modalConfirmState)
}

export const stopSendingCallback = ({
  set,
  snapshot,
  reset
}) => async idSchedule => {
  try {
    const { orderBy, orderDescending } = await snapshot.getPromise(
      sendListState
    )

    const res = await updateScheduleState(idSchedule, {
      State: 'Stopping'
    })
    if (res.Result === true) {
      const result = await getScheduledSendings({
        orderBy: orderBy,
        orderDescending: orderDescending
      })
      set(sendListState, prev => ({
        ...prev,
        items: result.Items,
        isEmptyState: result.Items.length === 0
      }))
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Rcs.SendStatusToastSuccessStopSending'
        }),
        TOAST_VARIANT_SUCCESS,
        'SendStatusToastSuccessStopSending'
      )
    } else {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'ErrorGeneric'
      )
    }
  } catch (error) {
    logAppError({ appError: error })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
  reset(modalConfirmState)
}

export const deleteSendingCallback = ({
  set,
  snapshot,
  reset
}) => async idSending => {
  try {
    const { orderBy, orderDescending } = await snapshot.getPromise(
      sendListState
    )

    const res = await deleteSending(idSending)
    if (res.Result === true) {
      const result = await getScheduledSendings({
        orderBy: orderBy,
        orderDescending: orderDescending
      })
      set(sendListState, prev => ({
        ...prev,
        items: result.Items,
        isEmptyState: result.Items.length === 0
      }))
    } else {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'ErrorGeneric'
      )
    }
  } catch (error) {
    logAppError({ appError: error })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
  reset(modalConfirmState)
}
